@if (
  toastService.topBannerMessages().length ||
  toastService.applicationMessages().length
) {
  <div class="top-banner position-fixed w-100">
    @if (toastService.topBannerMessages().length) {
      <div class="container-fluid top-banner-messages-container">
        <div class="row">
          <div class="col-sm-10 mx-auto">
            @for (u of toastService.topBannerMessages(); track u) {
              <div class="top-banner-message">
                <div class="row align-items-center">
                  <div class="col-sm-10">
                    <p class="top-banner-text">
                      <span class="bold d-block color-white">{{
                        u.title
                      }}</span>
                      <span class="color-white">{{ u.text }}</span>
                    </p>
                  </div>
                  <div
                    class="col-sm-2 top-banner-times text-center color-white"
                  >
                    <i
                      (click)="close(u.topBannerMessageId)"
                      class="fal fa-times"
                    ></i>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (toastService.applicationMessages().length) {
      @for (
        applicationMessage of toastService.applicationMessages();
        track applicationMessage
      ) {
        <div
          class="container-fluid"
          [class.alert-info]="
            applicationMessage.applicationMessageTypeId ===
            ApplicationMessageTypeEnum.Info
          "
          [class.alert-warning]="
            applicationMessage.applicationMessageTypeId ===
            ApplicationMessageTypeEnum.Warning
          "
          [class.alert-danger]="
            applicationMessage.applicationMessageTypeId ===
            ApplicationMessageTypeEnum.Danger
          "
        >
          <div class="row">
            <div class="col-sm-10 mx-auto">
              <div class="top-banner-message">
                <div class="row align-items-center">
                  <div class="col-sm-10">
                    <p class="top-banner-text">
                      <span class="bold d-block">{{
                        "applicationMessage" | translate
                      }}</span>
                      <span>{{ applicationMessage.message }}</span>
                    </p>
                  </div>
                  @if (applicationMessage.applicationMessageId != null) {
                    <div class="col-sm-2 top-banner-times text-center">
                      <i
                        (click)="
                          closeApplicationMessage(
                            applicationMessage.applicationMessageId
                          )
                        "
                        class="fal fa-times"
                      ></i>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>
}
@if (showBackdrop) {
  <div class="top-banner-backdrop"></div>
}
